import React from "react";
import DynamicComponent from "./DynamicComponent";
import { sbEditable } from "@storyblok/storyblok-editable";
import Seo from "../utils/seo";

const Page = ({ blok }) => {
  const content =
    blok.body &&
    blok.body.map((childBlok) => (
      <DynamicComponent
        blok={{
          ...childBlok,
          primary_colour: blok.primary_colour?.color,
          secondary_colour: blok.secondary_colour?.color,
          text_colour: blok.text_colour?.color,
          content_type: blok.component,
          breadcrumbs: blok.breadcrumbs?.crumbs,
          first_published_at: blok.first_published_at,
        }}
        key={childBlok._uid}
      />
    ));

  return (
    <div {...sbEditable(blok)}>
      <Seo
        pageName={blok?.name}
        pageMeta={blok?.meta}
        noindex={blok?.no_index}
      />
      {content}
    </div>
  );
};

export default Page;
